import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu"
import * as React from "react"

import { cn } from "./util"

function NavigationMenu({
    className,
    children,
    ...props
}: React.ComponentProps<typeof NavigationMenuPrimitive.Root> & {
    viewport?: boolean
}) {
    return (
        <NavigationMenuPrimitive.Root data-slot="navigation-menu" className={cn(className)} {...props}>
            {children}
        </NavigationMenuPrimitive.Root>
    )
}

function NavigationMenuList({ className, ...props }: React.ComponentProps<typeof NavigationMenuPrimitive.List>) {
    return (
        <NavigationMenuPrimitive.List
            data-slot="navigation-menu-list"
            className={cn("group flex flex-1 list-none items-center justify-center", className)}
            {...props}
        />
    )
}

function NavigationMenuItem({ className, ...props }: React.ComponentProps<typeof NavigationMenuPrimitive.Item>) {
    return <NavigationMenuPrimitive.Item data-slot="navigation-menu-item" className={cn(className)} {...props} />
}
const NavigationMenuTrigger = React.forwardRef<
    HTMLButtonElement,
    React.ComponentProps<typeof NavigationMenuPrimitive.Trigger>
>(({ className, children, ...props }, ref) => {
    return (
        <NavigationMenuPrimitive.Trigger
            ref={ref}
            data-slot="navigation-menu-trigger"
            className={cn("group", className)}
            {...props}>
            {children}
        </NavigationMenuPrimitive.Trigger>
    )
})
NavigationMenuTrigger.displayName = "NavigationMenuTrigger"
function NavigationMenuContent({ className, ...props }: React.ComponentProps<typeof NavigationMenuPrimitive.Content>) {
    return <NavigationMenuPrimitive.Content data-slot="navigation-menu-content" className={cn(className)} {...props} />
}

function NavigationMenuViewport({
    className,
    ...props
}: React.ComponentProps<typeof NavigationMenuPrimitive.Viewport>) {
    return (
        <NavigationMenuPrimitive.Viewport data-slot="navigation-menu-viewport" className={cn(className)} {...props} />
    )
}

const NavigationMenuLink = React.forwardRef<
    HTMLAnchorElement,
    React.ComponentProps<typeof NavigationMenuPrimitive.Link>
>(({ className, ...props }, ref) => {
    return (
        <NavigationMenuPrimitive.Link ref={ref} data-slot="navigation-menu-link" className={cn(className)} {...props} />
    )
})
NavigationMenuLink.displayName = "NavigationMenuLink"

function NavigationMenuIndicator({
    className,
    ...props
}: React.ComponentProps<typeof NavigationMenuPrimitive.Indicator>) {
    return (
        <NavigationMenuPrimitive.Indicator data-slot="navigation-menu-indicator" className={cn(className)} {...props} />
    )
}

export {
    NavigationMenu,
    NavigationMenuContent,
    NavigationMenuIndicator,
    NavigationMenuItem,
    NavigationMenuLink,
    NavigationMenuList,
    NavigationMenuTrigger,
    NavigationMenuViewport,
}
